import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import pdf from "../../Assets/saumyabhattresume.pdf";


function Resume() {
  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>

        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="Machine Learning Developer"
              date="May 2021 - Present"
              content={[
                "Working in the Machine Learning department of a software company.",
                "Currently working with ML Algorithms and applying my knowledge to solve business problems.",
              ]}
            />
            <Resumecontent
              title="Robotic Process Automation Developer"
              date="October 2020 - April 2021"
              content={[
                "Implemented RPA solutions to solve problems and make processes more streamlined and reliable.",
                "Completed multiple client projects based on Finance successfully.",
              ]}
            />
            <Resumecontent
              title="Machine Learning/Deep Learning Developer"
              date="May 2020 - August 2020"
              content={[
                "Developed deep learning based 'Facial Recognition System' which identifies and marks attendance.",
                "Trained the model on custom dataset made from 2500 human faces. Also, implemented functionality to detect 'Facial Emotions'.",
              ]}
            />

          </Col>

          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="Uka Tarsadia University"
              date="2016 - 2020"
              content={[]}
            />
            <Resumecontent
              title="Saraswati International School"
              date="2015 - 2016"
              content={[]}
            />
            <Resumecontent
              title="Saraswati International School"
              date="2014 - 2015"
              content={[]}
            />
            <h3 className="resume-title">Extracurricular Activities</h3>
            <Resumecontent
              title="Competitive Programming"
              content={[
                "I love enhancing my skill through competitive programming. I practice it on Hacker rank and Code Chef.",
              ]}
            />
            <Resumecontent
              title="Online Learning"
              content={[
                "I believe in the concept of gaining knowledge continuously, so I keep upgrading my skills through online learning platforms.",
              ]}
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
